module.exports = __webpack_public_path__ + "static/img/3.b44b7d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/3.png
// module id = 8kgH
// module chunks = 0